import React, { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import { getOrgImageUrl } from '../utils/getOrgImageUrl'
import FormatQuestionAnsweredBy from '../dashboard/FormatQuestionAnsweredBy'
import { getDate } from '../utils/getDate'
import YellowAlert from '../ui-elements/YellowAlert'
import Spinner from '../ui-elements/Spinner'



type Props = {
  answerNotes: ObjectStringKeyAnyValue
}

function ListAnswerNotes({
  answerNotes
}: Props) {



  const {
    organisationImageCode,
    t
  } = useContext(GlobalContext)

const [sortedNotes, setSortedNotes] = useState<Array<any> | null>(null)

useEffect(() => {
  sortKeysByTimestamp()
}, [answerNotes])

const sortKeysByTimestamp = () =>  {
  const entries = Object.entries(answerNotes)
  entries.sort((a, b) => {
      return b[1].Timestamp - a[1].Timestamp;
  })
  const sortedKeys = entries.map(([key]) => key);
  setSortedNotes(sortedKeys)
}

  return <div className={`flex flex-col gap-2`}>
    <h4 className={`text-xl font-righteous text-brandblue`}>{t('QuestionPages.ListAnswerNotes.notes')}</h4>

    {!sortedNotes && <Spinner>{t('General.loading')}</Spinner>}

    {sortedNotes && <div className={`flex flex-col gap-2`}>
      {sortedNotes.map((noteId: string, index: number) => {
        const thisNote = answerNotes[noteId]
        return <YellowAlert key={index}>
          <div className={`flex flex-col gap-2 items-center justify-center`}>
          {thisNote.PhotoNoteFileName && typeof thisNote.PhotoNoteFileName === 'string' && 
          <a
            href={getOrgImageUrl(organisationImageCode, thisNote.PhotoNoteFileName)}
            target='_blank' className={`hover:opacity-80`}>
            <img
              src={getOrgImageUrl(organisationImageCode, thisNote.PhotoNoteFileName)}
              alt=''
              className={`rounded bg-gray-300 min-w-12 min-h-12 max-w-36 max-h-36`}
            /></a>}
            {thisNote.AnswerNote && <p>"{thisNote.AnswerNote}"</p>}
            <p className={`text-xs italic text-gray-600`}>
              {t('QuestionPages.ListAnswerNotes.addedBy')} <FormatQuestionAnsweredBy questionAnswer={thisNote} /> {t('QuestionPages.ListAnswerNotes.on')} {getDate(thisNote.Timestamp, 'formattedDateAndTime')}
            </p>
          </div>    
        </YellowAlert>
      })}
    </div>}
  </div >
}
export default ListAnswerNotes